import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
import { region } from '@/utils/utils'
import { formatFDSImageWebp } from '@/utils/webp'
import { cookiePolicyList } from '@/components/CookieActionSheet/consts'
import * as utils from '@/utils/utils'
import { isMobile, isHorizontalScreen } from '@/utils/platform'
import { isNeedDeal } from '@/utils/getappMlbb'
import handleIdMap from '@/utils/idmap'
import { isInPubgmGame } from '@/utils/pubgm'
import '@/utils/autoRefresh'

import { getQuery } from '@/utils/utils'
import { storage, gameUidKey } from '@/utils/storage'
import { CODE_MODEL_GAME_LIST } from '@page_detail/config'
import { arrangeContext } from '@/utils/ssrDetails'

export default (context) => {
  const { route, store } = context

  // warn: 动态加载facebook
  const _region = region()
  if (_region !== 'ru') {
    const faceBookScript = document.createElement('script')
    faceBookScript.type = 'text/javascript'
    faceBookScript.id = '__facebook__'
    faceBookScript.src =
      'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0'
    faceBookScript.async = true
    faceBookScript.defer = true
    document.querySelector('body').appendChild(faceBookScript)
  }

  // lazyload
  Vue.use(VueLazyLoad, {
    filter: {
      // webp处理 & 域名分片处理，图片单独使用一个域名
      webp(listener, options) {
        const supportWebp = options.supportWebp
        if (window) {
          window.supportWebp = supportWebp
        }
        // base64不处理
        if (/^data:image\//.test(listener.src)) return
        listener.src = formatFDSImageWebp(listener.src)
      },
    },
  })

  // GT与Toplupe ID
  if (route && route.query && route.query.sf) {
    handleIdMap(route.query.sf)
  }

  const currentIsMobile = !!isMobile() // 是否为移动端
  const isDesktop = !isMobile() // 是否为桌面设备
  const isMiuiBrowser = utils.isMiuiBrowser() // 是否为国际版小米浏览器
  const isXiaomiDevice = utils.isXiaomiDevice() // 是否为小米设备
  const isChromeBrowser = utils.isChromeBrowser() // 是否为小米设备
  const isApp = utils.isInCoinsApp() // 是否为APP
  const isTurbo = route.query.mode === 'gt' && currentIsMobile
  const isPwa = !!utils.isPwa()
  const currentRegion = utils.region()
  const gameName = arrangeContext(context)?.game || ''
  const isGetapps = isNeedDeal()

  hackCouponUid(gameName, store, currentRegion)

  store.commit('changeStore', {
    cookiePolicyList,
    isMobile: currentIsMobile,
    isDesktop,
    isMiuiBrowser,
    isXiaomiDevice,
    isChromeBrowser,
    isApp,
    isTurbo,
    isPwa,
    region: currentRegion,
    gameName,
    isGetapps,
    isHorizontalScreen: isHorizontalScreen(),
    showLandscapeGuide: utils.isShowLandscapeGuide({
      gameName,
      isInPubgmGameApp: isInPubgmGame(),
      isDesktop,
      isTurbo,
      region: currentRegion,
      isApp,
    }),
  })

  hackPayResult(gameName, store)

  // 提前初始化pubgm ios
  // initPubgmIOSBridge()

  // 在客户端重新生成响应的时间戳
  const preApiSign = store?.state?.common?.apiSign || {}
  const currentTs = new Date().getTime()
  preApiSign.responseTime = currentTs
  store.commit('common/changeStore', {
    apiSign: { ...preApiSign },
  })
}

// hack  兼容优惠券风控UID的时候重复触发watch的问题
function hackCouponUid(gameName, store, region) {
  let selectedUidKey = ``
  if (gameName === 'mobile-legends') {
    selectedUidKey = `${gameUidKey}-${region}-${gameName}`
  } else {
    // warn： code 模式不存储UID校验
    if (!CODE_MODEL_GAME_LIST.includes(gameName)) {
      selectedUidKey = `@@top-selected-uid-${gameName}`
    }
  }

  const suid = storage.get(selectedUidKey) || ''
  store.commit('detail/setUserId', suid)
}

// hack 默认注入gameName
function hackPayResult(gameName, store) {
  const _game = gameName || getQuery('game') || ''

  store.commit('setGameName', _game)
}
